import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandFuelTruckPage } from './cabsand-fuel-truck';

@NgModule({
  declarations: [
    CabsandFuelTruckPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandFuelTruckPage),
  ],
})
export class CabsandFuelTruckPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-fuel-truck/cabsand-fuel-truck.module.ts